import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addRespUso, removeRespUso } from "../../../../../../../../../../../redux/actions/resolucion";
import ResponsableUsoFormContainer from './ResponsableUsoFormContainer';
import ResponsableUsoTable from "./ResponsableUsoTable";

const ResponsableUsoTableContainer = () => {
    const dispatch = useDispatch();
    const idDependenciaEmpleador = useSelector((state) => state.resolucion.searchedEstablecimiento);
    const data = useSelector((state) => state.resolucion.abmEquiposRadiologicos.respUso);

    const [openRespUsoForm, setOpenRespUsoForm] = useState(false);
    const [respUso, setRespUso] = useState(null);

    const handleRemoveRespUso = (row) => {
        dispatch(removeRespUso(row));
    };
    const handleOpenRespUsoForm = (rowData) => {
        setOpenRespUsoForm(true);
        setRespUso(rowData);
    };

    const handleSubmitRespUso = (values) => {
        const body = {
            ...values,
            idDependenciaEmpleador: idDependenciaEmpleador,
        };
        dispatch(addRespUso(body, values.index));
        setOpenRespUsoForm(false);
    };

    return (
        <>
            <ResponsableUsoTable
                handleDelete={handleRemoveRespUso}
                handleOpenForm={handleOpenRespUsoForm}
                data={data}
            />
            <ResponsableUsoFormContainer
                handleClose={() => setOpenRespUsoForm(false)}
                open={openRespUsoForm}
                handleSubmit={handleSubmitRespUso}
                values={respUso}
            />
        </>
    )
}

export default ResponsableUsoTableContainer;